export const takeoverCategories = ['ESS', 'FW Team Work', 'FW', 'Automatic'] as const
export const takeoverStatuses = ['尚未開始', '進行中', '無實機環境', '已完成'] as const
export const projectTypes = ['AI Server', 'PowerEdge', 'Storage'] as const
export const projectStatuses = ['待啟動', '進行中', '正常', '風險', '已完成'] as const
export const readinessStatuses = ['待確認', '準備測試', '待測試', '測試中', '已完成', '不需測試', '警示', '阻塞'] as const
export const readinessStatusColors = [
  { value: 'white', label: '白' },
  { value: 'blue', label: '藍' },
  { value: 'green', label: '綠' },
  { value: 'yellow', label: '黃' },
  { value: 'red', label: '紅' },
  { value: 'gray', label: '灰' },
] as const
export const workingStatusOptions = [
  { value: 'green', label: '綠 (正常 / On Track)' },
  { value: 'yellow', label: '黃 (警示 / Warning)' },
  { value: 'red', label: '紅 (嚴重阻塞 / Blocked)' },
  { value: 'white', label: '白 (預設 / 未啟動)' },
] as const
export const workingItemOwners = ['Jerry', 'Roger', 'Po-Hung', 'Eric', 'Steven', 'KC'] as const

export const workingStatusLight = (status: string) => {
  if (['green', 'yellow', 'red', 'white'].includes(status)) return status as 'green' | 'yellow' | 'red' | 'white'
  if (status === '阻塞') return 'red'
  if (status === '待處理') return 'yellow'
  if (status === '進行中' || status === '已完成') return 'green'
  return 'white'
}

export const workingStatusLabel = (status: string) => {
  const color = workingStatusLight(status)
  return workingStatusOptions.find((option) => option.value === color)?.label ?? workingStatusOptions[3].label
}

export const statusTone = (status: string) => {
  if (['已完成', '正常'].includes(status)) return 'green'
  if (['進行中', '待確認'].includes(status)) return 'amber'
  if (['風險', '阻塞', '無實機環境'].includes(status)) return 'red'
  return 'gray'
}

export const defaultReadinessStatusColor = (status: string) => {
  if (status === '準備測試') return 'blue' as const
  if (status === '待測試' || status === '測試中') return 'green' as const
  if (status === '已完成') return 'green' as const
  if (status === '警示') return 'yellow' as const
  if (status === '阻塞') return 'red' as const
  if (status === '不需測試') return 'gray' as const
  return 'white' as const
}

export const defaultProjectStatusColor = (status: string) => {
  if (status === '進行中' || status === '正常' || status === '已完成') return 'green' as const
  if (status === '風險') return 'red' as const
  return 'gray' as const
}

export const formatUpdatedAt = (value: string) => {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return new Intl.DateTimeFormat('zh-TW', {
    month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false,
  }).format(date)
}
